import { render } from "./EmployeeViewRequest.vue?vue&type=template&id=42e38532"
import script from "./EmployeeViewRequest.vue?vue&type=script&lang=js"
export * from "./EmployeeViewRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__